import { Checkbox as UiCheckbox } from "@rumbledirect/ui";
import { QuestionCheckboxModel, ItemValue } from "survey-core";
import { SurveyElementBase } from "survey-react-ui";
import { useMemo } from "react";
import { createStyles } from "antd-style";

const useStyles = createStyles(({ css }) => ({
  checkboxGroup: css`
    .ant-checkbox-wrapper {
      font-size: 15px;
    }
  `,
}));

interface CheckboxQuestionWithOrientation extends QuestionCheckboxModel {
  orientation?: "horizontal" | "vertical";
}

export const CheckboxGroupQuestion = (props: {
  question: CheckboxQuestionWithOrientation;
}) => {
  const { styles } = useStyles();
  const options = useMemo(
    () =>
      props.question.visibleChoices.map((c: ItemValue) => ({
        value: c.value,
        label: SurveyElementBase.renderLocString(c.locText),
      })),
    [props.question.visibleChoices],
  );

  const onCheckboxChange = (checkedValues: (string | number | boolean)[]) => {
    props.question.value = checkedValues;
  };

  const isVertical = props.question.orientation !== "horizontal";

  return (
    <UiCheckbox.Group
      options={options}
      value={props.question.value || []}
      disabled={props.question.isDisabledAttr}
      onChange={onCheckboxChange}
      className={styles.checkboxGroup}
      style={{
        display: "flex",
        flexDirection: isVertical ? "column" : "row",
        flexWrap: "wrap",
        gap: isVertical ? "8px" : "16px",
      }}
    />
  );
};
